var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'btn sam-primary-button mt-0',
    { 'mb-4': !_vm.noSpace && !_vm.customClass.includes('mb-') },
    _vm.customClass,
    { 'alert-button': _vm.alertButton }
  ],attrs:{"type":"button","disabled":_vm.disabled === true},on:{"click":function($event){return _vm.buttonAction()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }